<template>
  <v-card tile flat>
    <v-card-title>
      <v-text-field
        v-bind:value="filter"
        v-on:input="applyFilter"
        prepend-inner-icon="mdi-magnify"
        label="Filtra"
        clearable
        flat
        hide-details
        autofocus
        dense
      />
      <v-spacer />
      <v-btn v-on:click="newService" class="primary">Nuovo servizio</v-btn>
    </v-card-title>

    <v-card-text style="position: relative;">
      <v-data-table
        v-bind:headers="headers"
        v-bind:options.sync="options"
        v-bind:items="rows"
        v-bind:server-items-length="totalRows"
        v-bind:loading="server_loading"
        v-bind:footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
        v-on:click:row="editService"
        calculate-widths
      >
        <template v-slot:item.description="{ item }">
          <v-icon v-if="item.active === '0'" class="mr-1 grey--text" small>mdi-eye-off</v-icon>
          <span v-bind:class="{ 'grey--text': item.active === '0' }">{{ item.description }}</span>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="editingService" width="600">
      <v-card>
        <v-card-title>
          <span v-if="selectedService.id">Modifica servizio</span>
          <span v-if="!selectedService.id">Nuovo servizio</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="9">
                <v-text-field
                  ref="selectedServiceDescription"
                  v-model="selectedService.description"
                  label="Descrizione"
                  v-bind:rules="[rules.required]"
                />
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="selectedService.active"
                  true-value="1"
                  false-value="0"
                  label="Attivo"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn class="primary" v-on:click="saveService">Salva</v-btn>
          <v-btn class="primary" v-on:click="closeService">Annulla</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import server from '../mixins/server'
import utils from '../mixins/utils'

export default {
  name: 'Services',

  mixins: [ server, utils ],

  data: () => ({
    headers: [
      { text: 'Descrizione', value: 'description' },
    ],
    filter: '',
    totalRows: 0,
    rows: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['description'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
    rules: {
      required: value => !!value || 'Valore richiesto.',
    },
    valid: false,
    selectedService: {},
  }),

  watch: {
    options: {
      handler () { this.loadRows(); },
      deep: true,
    },
    editingService: {
      handler (newValue) { newValue && this.utils_focusInput('selectedServiceDescription', 200); }
    },
  },

  computed: {
    editingService: {
      get: function() { return 'id' in this.selectedService; },
      set: function(value) { if (!value) this.selectedService = {}; },
    },
  },

  methods: {
    applyFilter: function(value) {
      this.filter = value;

      // When appling the filter we move to first page and this
      // forces the reload of the rows
      this.utils_delayExecute((this.options.page != 1) ? this.loadFirstPage : this.loadRows);
    },

    loadFirstPage: function() {
      this.options.page = 1;
    },

    loadRows: function() {
      const parameters = {};

      parameters['page'] = this.options.page;
      parameters['rows'] = this.options.itemsPerPage;

      // Add filter
      if (this.filter) {
        parameters['filter'] = this.filter;
      }

      // Add sorting
      if (this.options.sortBy.length > 0) {
        parameters['order'] = this.options.sortBy[0];
        if (this.options.sortDesc[0]) {
          parameters['order'] = '-' + parameters['order'];
        }
      }

      this.server_query({
        url: 'Service/list',
        parameters: parameters,
        onError: () => {
          this.rows = [];
          this.totalRows = 0;
        },
        onSuccess: (data) => {
          this.rows = data.rows;
          this.totalRows = data.total;
        },
      });
    },

    newService: function() { this.selectedService = { id: 0, active: '1', description: '' }; },

    editService: function(item) { this.selectedService = Object.assign({}, item); },

    closeService: function() { this.selectedService = {}; },

    saveService: function() {
      // Validate form first
      if (this.$refs.form.validate()) {
        const parameters = {
          url: `Service/index/${this.selectedService.id || 0}`,
          data: this.selectedService,
          onSuccess: () => {
            this.closeService();
            this.loadRows();
          }
        };

        if (this.selectedService.id) {
          this.server_update(parameters);
        } else {
          this.server_save(parameters);
        }
      }
    },
  }
}
</script>
